'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dTarget from "./io.intela.sites.intelacloud.content.-Target.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Target$Section(id) {
  this.ia = null;
  this.ia = id;
}
export { $c_Lio_intela_sites_intelacloud_content_Target$Section as $c_Lio_intela_sites_intelacloud_content_Target$Section };
$p = $c_Lio_intela_sites_intelacloud_content_Target$Section.prototype = new $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dTarget.$h_Lio_intela_sites_intelacloud_content_Target();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Target$Section;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Target$Section() {
}
export { $h_Lio_intela_sites_intelacloud_content_Target$Section as $h_Lio_intela_sites_intelacloud_content_Target$Section };
$h_Lio_intela_sites_intelacloud_content_Target$Section.prototype = $p;
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-162532404), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Target$Section) && (this.ia === x$0.ia)));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "Section";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.ia;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Target$Section(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bK)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Target$Section as $isArrayOf_Lio_intela_sites_intelacloud_content_Target$Section };
var $d_Lio_intela_sites_intelacloud_content_Target$Section = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Target$Section, "io.intela.sites.intelacloud.content.Target$Section", ({
  bK: 1,
  aI: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Target$Section as $d_Lio_intela_sites_intelacloud_content_Target$Section };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Target$-Section.js.map
